import React from 'react';
import {Profile} from '../../interfaces';
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import {Button, Paper} from '@mui/material';

interface Props {
  profiles: Profile[];
  onDeleteProfile: (id: number) => void;
  onRestoreProfile: (id: number) => void;
}

const ProfileDeleteRequestsTable: React.FC<Props> = ({
  profiles,
  onDeleteProfile,
  onRestoreProfile,
}) => {
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      width: 90,
      filterable: true,
    },
    {
      field: 'firstName',
      headerName: 'First Name',
      filterable: true,
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      filterable: true,
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 300,
      filterable: true,
    },
    {
      field: 'deletedAt',
      headerName: 'Deleted At',
      width: 200,
      filterable: true,
      valueFormatter: val => {
        if (val.value) {
          return new Date(parseInt(val.value));
        }
        return '';
      },
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Delete',
      width: 80,
      renderCell: val => {
        return (
          <Button onClick={() => onDeleteProfile(val.id as number)}>
            Delete
          </Button>
        );
      },
    },
    {
      field: 'restore',
      type: 'actions',
      headerName: 'Restore',
      width: 80,
      renderCell: val => {
        return (
          <Button onClick={() => onRestoreProfile(val.id as number)}>
            Restore
          </Button>
        );
      },
    },
  ];

  return (
    <Paper sx={{height: 700}}>
      <DataGrid rows={profiles ?? []} columns={columns} />
    </Paper>
  );
};

export default React.memo(ProfileDeleteRequestsTable);
